<template>
  <div class="tab">
    <div
      v-for="(item, index) in tabList"
      :key="index"
      class="opt pointer fx-aj-c"
      :class="{ b: tabPath === item.path }"
      @click="$emit('tab-change', item)"
    >
      <template v-if="item.path === '/whatsapp'">
        <template v-if="waIsLogin">
          <el-badge :value="waBadgeCount" :hidden="waBadgeCount === 0" class="wa-tab-badge">
            <img v-if="tabPath === item.path" :src="item.src" />
            <img v-else :src="item.srcb" />
          </el-badge>
        </template>
        <template v-else>
          <img v-if="tabPath === item.path" :src="item.src" />
          <img v-else :src="item.srcb" />
        </template>
      </template>

      <template v-else-if="item.path === '/email'">
        <div class="email-badge-wrapper">
          <img v-if="tabPath === item.path" :src="item.src" />
          <img v-else :src="item.srcb" />
          <span v-show="emailBadgeDotVisible" class="email-badge-dot"></span>
        </div>
      </template>

      <template v-else>
        <img v-if="tabPath === item.path" :src="item.src" />
        <img v-else :src="item.srcb" />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderTabs',
  props: {
    tabList: {
      type: Array,
      default: () => [],
    },
    tabPath: {
      type: String,
      default: '',
    },
    waIsLogin: {
      type: Boolean,
      default: false,
    },
    waBadgeCount: {
      type: Number,
      default: 0,
    },
    emailBadgeDotVisible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['tab-change'],
}
</script>

<style scoped>
.tab {
  display: flex;
}

.opt {
  width: 85px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.opt.b {
  background: #ffebeb;
}

.opt img {
  width: 25px;
  height: 25px;
}

.pointer {
  cursor: pointer;
}

.fx-aj-c {
  align-items: center;
  justify-content: center;
}

.wa-tab-badge {
  position: relative;
  display: inline-block;
  line-height: 0;
}

.wa-tab-badge :deep(.el-badge__content) {
  position: absolute;
  top: -8px !important;
  right: -8px !important;
  transform: translateX(50%) translateY(-50%);
}

.email-badge-wrapper {
  position: relative;
  display: inline-block;
  line-height: 0;
}

.email-badge-dot {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 13px;
  height: 13px;
  background-color: var(--el-color-danger);
  border-radius: 50%;
  border: 1px solid #fff;
}
</style>
